import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import MedicaidChipApplication from '../../menforms/form/MedicaidChip'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Medicaid/Chip Application || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="Medicaid/Chip Application"
            subtitledown="Medicaid/Chip Application"
           />
            <MedicaidChipApplication/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main